import { useDispatch } from 'react-redux';

import { FEATURE_FLAGS, FeatureFlag, type FeatureFlags } from 'app/api/services/site-configs/types';

import useCurrentRegion from 'app/lib/region/useCurrentRegion';
import { allowFreshChat } from 'app/ssr/config';

import { featureFlagsAction } from '../site-configs/slice';

export const useProcessFlags = (): (ff: string) => void => {
  const dispatch = useDispatch();
  const currentRegion = useCurrentRegion();

  const processFlags = (ff: string) => {
    const featureFlags: FeatureFlags[] = [];

    ff && ff.split(',').forEach((featureFlag) => {
      if (isFeatureFlag(featureFlag)) {
        featureFlags.push(featureFlag);
      }
      else {
        console.error(`Фича-флага ${featureFlag} не существует. Доступные фича-флаги: ${FEATURE_FLAGS.toString()}`);
      }
    });

    const allowWholeFooter = Boolean(currentRegion);
    const allowBanners = Boolean(currentRegion);
    const allowMobileAppIcons = Boolean(currentRegion);
    const allowSupport = allowFreshChat;
    const allowGames = Boolean(currentRegion);
    const allowPayment = Boolean(currentRegion);
    const allowRegistration = Boolean(currentRegion);

    // Remove after complete transition on ANTLR ->
    const isANTLR = featureFlags.includes(FeatureFlag.ANTLR);

    if (isANTLR) {
      typeof window !== 'undefined' ? window.__env.ANTLR = 'true' : process.env.ANTLR = 'true';
    }

    const isANTLRErrors = featureFlags.includes(FeatureFlag.ANTLR_ERRORS);

    if (isANTLRErrors) {
      typeof window !== 'undefined' ? window.__env.ANTLR_ERRORS = 'true' : process.env.ANTLR_ERRORS = 'true';
    }
    // Remove after complete transition on ANTLR <-

    if (allowWholeFooter) {
      featureFlags.push(FeatureFlag.ALLOW_WHOLE_FOOTER);
    }

    if (allowBanners) {
      featureFlags.push(FeatureFlag.ALLOW_BANNERS);
    }

    if (allowMobileAppIcons) {
      featureFlags.push(FeatureFlag.ALLOW_MOBILE_APP_ICONS);
    }

    if (allowSupport) {
      featureFlags.push(FeatureFlag.ALLOW_SUPPORT);
    }

    if (allowGames) {
      featureFlags.push(FeatureFlag.ALLOW_GAMES);
    }

    if (allowPayment) {
      featureFlags.push(FeatureFlag.ALLOW_PAYMENT);
    }

    if (allowRegistration) {
      featureFlags.push(FeatureFlag.ALLOW_REGISTRATION);
    }

    if (featureFlags.length) {
      dispatch(featureFlagsAction(featureFlags));
    }
  };

  return processFlags;
};

// TODO: https://github.com/total-typescript/ts-reset#make-includes-on-as-const-arrays-less-strict
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type UnknownFlag = any;

function isFeatureFlag(flag: UnknownFlag): flag is FeatureFlags {
  return FEATURE_FLAGS.includes(flag);
}
